export const languages = ['en', 'cs']

export const defaultLanguage = languages[0]



// WEBPACK FOOTER //
// ./src/shared/languages.ts